import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import router from '../router'
import auth from "../config/auth"
import api from "../config/api"

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        form_data: {},
        content: '',
        color: '',
        loading: true,
        page: 1,
        games_per_page: 30,
        total_games: 30,
        finishes: [],
        settings: JSON.parse(
                localStorage.getItem('settings')) ||
            ({
                "filters": {},
                "highlights": { "fighters": [], "rounds": [], "time": [], "finish_coefs": [], "winner_coefs": [], "winner_match_coefs": [] },
                "cols": [],
                "colors": {
                    "fat": { "group": "Добивания", "menu": false, "text": "Фаталити", "hex": "#e57373", "name": "fat" },
                    "brut": { "group": "Добивания", "menu": false, "text": "Бруталити", "hex": "#81c784", "name": "brut" },
                    "hand": { "group": "Добивания", "menu": false, "text": "Без добивания", "hex": "#cfd8dc", "name": "hand" },
                    "winner": { "group": "Победы", "menu": false, "text": "Победитель", "hex": "#81c784", "name": "winner" },
                    "winner_coef": { "group": "Победы", "menu": false, "text": "Кф Победитель", "hex": "#ffb74d", "name": "winner_coef" },
                    "rusk": { "group": "Победы", "menu": false, "text": "Сухарь", "hex": "#ffcc80", "name": "rusk" },
                    "w1": { "group": "Победы", "menu": false, "text": "П1", "hex": "#fff59d", "name": "w1" },
                    "w2": { "group": "Победы", "menu": false, "text": "П2", "hex": "#ce93d8", "name": "w2" },
                    "fav_win": { "group": "Победы", "menu": false, "text": "Фаворит победа", "hex": "#b39ddb", "name": "fav_win" },
                    "out_win": { "group": "Победы", "menu": false, "text": "Аутсайдер победа", "hex": "#ff8a65", "name": "out_win" },
                    "min_less": { "group": "Время", "menu": false, "text": "Время меньше МИН", "hex": "#81c784", "name": "min_less" },
                    "min_more": { "group": "Время", "menu": false, "text": "Время больше МИН", "hex": "#e57373", "name": "min_more" },
                    "mean_less": { "group": "Время", "menu": false, "text": "Время меньше СР", "hex": "#c8e6c9", "name": "mean_less" },
                    "mean_more": { "group": "Время", "menu": false, "text": "Время больше СР", "hex": "#ffcdd2", "name": "mean_more" },
                    "max_less": { "group": "Время", "menu": false, "text": "Время меньше МАКС", "hex": "#81c784", "name": "max_less" },
                    "max_more": { "group": "Время", "menu": false, "text": "Время больше МАКС", "hex": "#e57373", "name": "max_more" }
                },
            }),
        pair_settings: JSON.parse(
            localStorage.getItem('settings')) || ({
            "filters": {},
            "highlights": { "fighters": [{ "fighters__left_fighter": "Горо" }], "rounds": [], "time": [], "finish_coefs": [], "winner_coefs": [], "winner_match_coefs": [] },
            "cols": ["wlr_percent", "wrr_percent", "fat_percent", "brut_percent", "r_percent", "more_than_mean_percent", "less_than_mean_percent"]
        }),
        template_uid: localStorage.getItem('template_uid') || '',
        templates: {},
        template_changed: localStorage.getItem('template_changed') || false,
        template_name: localStorage.getItem('template_name') || '',
        email: '',
        fightersHighlight: '',
        timesHighlight: '',
        saveTemplatePopup: false,
        saveTemplateText: '',
        cols: JSON.parse(localStorage.getItem('cols')) || ["id", "Дата", "Время суток",
            "Чистая победа", "П1 | П2", "П1Р | П2Р", "F | B | R", "Раунды",
            "Время", "Меньшее", "Среднее", "Большее", "Разница времени",
            "5.5Б", "5.5М", "6.5М", "6.5Б", "7.5М", "7.5Б", "8.5М", "8.5Б", "default"
        ],
        // cols: [
        //     "id", "Дата", "Время суток",
        //     "Чистая победа", "П1", "П2", "F", "B", "R", "Раунды",
        //     "Время", "Меньшее", "Среднее", "Большее",
        //     "5.5Б", "5.5М", "6.5М", "6.5Б", "7.5М", "7.5Б", "8.5М", "8.5Б", "default"
        // ],
        changeTemplatePopup: false,
        changeTemplateText: '',
        deleteTemplatePopup: false,
        deleteTemplateText: '',
        status: '',
        error: '',
        token: localStorage.getItem('token') || '',
        confirmDialog: false,
        exitDialog: false,
        menu: false,
        page_size: localStorage.getItem('page_size') || 25,
        changeDialog: false,
        expire_date: "",
        sub_type: 0,
        user: {}
    },
    getters: {
        isLoggedIn: state => !!state.token,
        authStatus: state => state.status,
        paginationLen: state => {
            let len =
                (state.total_games + state.games_per_page - 1) / state.page_size;
            len = Math.floor(len);
            return len;
        },
        getPageSize: state => state.page_size,
        finishes: state => {
            return state.finishes;
        },
        cols: state => {
            return state.cols;
        },
        getSubType: state => {
            return state.sub_type;
        },
        getExpireDate: state => {
            return state.expire_date;
        },
        getMenu: state => {
            return state.menu;
        },
        getHighlightFighters: state => {
            return state.fightersHighlight;
        },
        getHighlightTimes: state => {
            return state.timesHighlight;
        },
        getFormData: state => {
            return state.form_data;
        },
        getCurrentPage: state => {
            return state.page;
        },
        getTotalGames: state => {
            return state.total_games;
        },
        getLoading: state => {
            return state.loading;
        },
        gamesPerPage: state => {
            return state.games_per_page;
        },
        getStatus: state => {
            return state.status;
        },
        getConfirmDialog: state => {
            return state.confirmDialog;
        },
        getColors: state => {
            return state.settings.colors
        },
        getExitDialog: state => {
            return state.exitDialog;
        },
        getChangeDialog: state => {
            return state.changeDialog;
        },
        getError: state => {
            return state.error;
        },
        getEmail: state => {
            return state.email;
        },
        getCurrentTemplate: state => {
            if (state.templates.length != 0) {
                return state.template_name;
            } else {
                return ""
            }
        },
        getSettings: state => {
            return state.settings;
        },

        getPairSettings: state => {
            return state.pair_settings;
        },
        getUserTemplates: state => {
            return state.templates;
        },
        getCurrentTemplateUID: state => {
            if (state.templates.length != 0) {
                return state.template_uid;
            } else {
                return ""
            }
        },
        getIsTemplateChanged: state => {
            if (state.templates.length != 0) {
                return state.template_changed;
            } else {
                return false;
            }
            // return localStorage.getItem("template_changed")
        }
    },
    mutations: {
        auth_request(state) {
            state.status = 'loading'
                // console.log('loading')
        },
        auth_success(state, token, user) {
            // console.log('success')
            state.status = 'success'
            state.token = token
            state.user = user
        },
        auth_error(state, { msg }) {
            // console.log('error: ' + msg)
            state.status = 'error'
            state.error = msg
        },
        logout(state) {
            state.status = ''
            state.token = ''
        },
        setMenu(state) {
            state.menu = false;
        },
        setFormData(state, { form_data }) {
            // console.log(`Setting new formData: ${form_data}`)
            // state.form_data = form_data;
            Vue.set(state.form_data, form_data)
        },
        setCols(state, { value }) {
            if (value.indexOf("default") == -1) {
                value.push("default")
            }
            state.settings.cols = value;
            Vue.set(state.settings, "cols", value)
            localStorage.setItem("settings", JSON.stringify(state.settings))
        },
        setColors(state, { value }) {
            // console.log("Settings colors " + value[1].hex)
            state.settings.colors = value;
            Vue.set(state.settings, "colors", value)
                // console.log("COLORS AFTER: " + JSON.stringify(state.settings.colors))
            localStorage.setItem("settings", JSON.stringify(state.settings))
        },
        addCol(state, { value }) {
            state.settings.cols.push.push(value)
        },
        deleteCol(state, { col_to_delete }) {
            var index = state.cols.indexOf(col_to_delete);
            if (index !== -1) {
                state.cols.splice(index, 1);
            }
        },
        setFilterKey(state, { key, value }) {
            // state.form_data[key] = value;
            Vue.set(state.settings.filters, key, value)
            localStorage.setItem("settings", JSON.stringify(state.settings))
        },
        deleteFilterKey(state, { key_to_delete }) {
            // console.log(`Deleting: ${key_to_delete}`)
            Vue.delete(state.settings.filters, key_to_delete)
            localStorage.setItem("settings", JSON.stringify(state.settings))
                // delete state.form_data[key_to_delete];
        },
        addHighlight(state, { type, value }) {
            // state.form_data[key] = value;
            // var arr = state.settings.highlights[type]
            // console.log("Arr: " + arr)
            // console.log("type: " + type)
            // if (type == "fighters") {
            Vue.set(state.settings.highlights, type, value)
            localStorage.setItem("settings", JSON.stringify(state.settings))
            return
            // }
            // if (arr.indexOf(value) == -1) {
            //     Vue.set(state.settings.highlights, type, [value])
            //     localStorage.setItem("settings", JSON.stringify(state.settings))
            // }
        },
        deleteHighlight(state, { type, value }) {
            // console.log(`Deleting: ${value} from ${type}`)
            Vue.delete(state.settings.highlightsl[type], value)
            localStorage.setItem("settings", JSON.stringify(state.settings))
                // delete state.form_data[key_to_delete];
        },
        cleanAllFilters(state) {
            // console.log("In cleanAllFilters")
            state.settings.filters = {};
            localStorage.setItem("settings", JSON.stringify(state.settings))
                // console.log("Form data after clean: " + JSON.stringify(state.form_data))
        },
        cleanSettings(state) {
            // console.log("In cleanSettings")
            Vue.set(state.settings, 'filters', {});
            Vue.set(state.settings, 'cols', ['default']);
            Vue.set(state.settings.highlights, 'fighters', "");
            Vue.set(state.settings.highlights, 'rounds', []);
            Vue.set(state.settings.highlights, 'time', []);
            Vue.set(state.settings.highlights, 'finishes', []);
            Vue.set(state.settings.highlights, 'winner_coefs', "");
            Vue.set(state.settings.highlights, 'finish_coefs', "");
            localStorage.setItem("settings", JSON.stringify(state.settings))
                // console.log("Form data after clean: " + JSON.stringify(state.settings))
        },
        setCurrentPage(state, { page }) {
            state.page = page;
        },
        setTotalGames(state, { count }) {
            state.total_games = count;
        },
        setLoading(state, { value }) {
            state.loading = value;
        },
        setFinishes(state, { value }) {
            state.finishes = value;
        },
        setHighlightFighters(state, { value }) {
            state.fightersHighlight = value;
        },
        setHighlightTimes(state, { value }) {
            state.timesHighlight = value;
        },
        setConfirmDialog(state, { value }) {
            state.confirmDialog = value;
        },
        setExitDialog(state, { value }) {
            state.exitDialog = value;
        },
        setChangeDialog(state, { value }) {
            state.changeDialog = value;
        },
        setEmail(state, { email }) {
            // console.log("SETTING EMAIL: " + email)
            state.email = email
        },
        setTemplateUID(state, { value }) {
            state.template_uid = value;
            localStorage.setItem('template_changed', false)
            localStorage.setItem('template_uid', value)
        },
        setUserTemplates(state, { value }) {
            // console.log("SETTING TEMPLATES: " + value)
            // state.templates = value;
            Vue.set(state, "templates", value)
        },
        setUserSub(state, { value }) {
            // console.log("SETTINGS USER SUB: " + JSON.stringify(value))
            state.expire_date = value.expire_date
            state.sub_type = value.sub_type
        },
        setPageSize(state, { value }) {
            state.page_size = value;
            localStorage.setItem('page_size', value)
        },
        setSettings(state, { value }) {
            // state.settings = value;
            // console.log("SETTONG NEW SETTINGS: " + JSON.stringify(value))
            Vue.set(state, 'settings', value)
            localStorage.setItem('settings', JSON.stringify(value))
            localStorage.setItem('template_changed', false)
        },
        setTemplateChanged(state, { value }) {
            state.template_changed = value;
            localStorage.setItem('template_changed', value)
        },
        setCurrentTemplate(state, { value }) {
            state.template_name = value;
            localStorage.setItem('template_name', value)
                // localStorage.setItem('template_changed', false)
        },

        showMessage(state, payload) {
            state.content = payload.content
            state.color = payload.color
        }
    },
    actions: {
        async login({ commit, dispatch, getters }, user) {
            commit('auth_request')
            const resp = await auth({ url: '/auth/jwt/create/', data: user, method: 'POST' })
            const token = resp.data.access
            const refresh = resp.data.refresh
                // console.log(resp.data)
            localStorage.setItem('token', token)
            localStorage.setItem('refresh', refresh)
            auth.defaults.headers.common['Authorization'] = 'Bearer ' + token
            await dispatch("fetchUserTemplates")
            var templates = getters.getUserTemplates
            if (templates.length != 0) {
                await dispatch("setTemplateUID", { value: templates[0].uid })
                await dispatch("setCurrentTemplate", { value: templates[0].name })
                await dispatch("setSettings", { value: templates[0].settings })
            } else {
                console.log("No templates yet.")
            }
            await dispatch("fetchUserSub")

            commit('auth_success', token, user)
                // console.log("Finished in login")
        },
        logout({ commit }) {
            return new Promise((resolve) => {
                commit('logout')
                localStorage.removeItem('token')
                localStorage.clear()
                delete axios.defaults.headers.common['Authorization']
                router.push("/")
                resolve()
            })
        },
        async fetchUserSub({ commit, }) {
            var subscription;
            // console.log("FEtching subscription... ")

            try {
                const response = await api({ url: '/subscription/', method: 'GET' })
                subscription = response.data;
                if (subscription.length == 0) {
                    // console.log("NO SUB!")
                    commit("setUserSub", { value: { expire_date: "", sub_type: "" } })
                } else {
                    // this.setUserTemplates({ value: templates });
                    // console.log("sub from request:" + JSON.stringify(subscription));
                    commit("setUserSub", { value: response.data[0] })
                }
            } catch (error) {
                console.log("Error:" + JSON.stringify(error))
                    // vm.$store.dispatch("logout")
                    // vm.$router.push({ name: 'login' });
            }

            //   this.loading = false;

        },
        async fetchUserTemplates({ commit }) {
            var fetched_templates;
            // console.log("FEtching templates...")
            const response = await api({ url: '/templates/get_template/', method: 'GET' })
            fetched_templates = response.data;
            // this.setUserTemplates({ value: templates });
            // console.log("templates from request:" + JSON.stringify(fetched_templates));
            //   this.loading = false;
            commit("setUserTemplates", { value: fetched_templates });
            // console.log("Sat templates")
            // .catch((error) => {
            //     console.log(error.data);
            //     reject(error)
            // })
        },
        isTemplateChanged({ getters, dispatch }) {
            // console.log("IN TEMPLATE CHANGED")
            var current_uid = getters.getCurrentTemplateUID
            var settings = getters.getSettings
                // Templates from db
            var cur_templates = getters.getUserTemplates
                // console.log("UID: " + current_uid)
                // console.log("templates: " + JSON.stringify(cur_templates))

            // :TODO add colors to all templates
            for (var cur_template in cur_templates) {
                var tmp_uid = cur_templates[cur_template].uid;
                if (tmp_uid == current_uid) {
                    var template_settings = cur_templates[cur_template].settings
                        // console.log(
                        // "Default settings: " + JSON.stringify(template_settings)
                        // );
                        // console.log("Current settings: " + JSON.stringify(settings))
                    var is_changed = JSON.stringify(template_settings) !== JSON.stringify(settings)
                        // console.log("Is changed: " + is_changed)
                    dispatch("setTemplateChanged", { value: is_changed });
                    // return template_settings == settings
                    // dispatch("setSettings", { value: templates[template].settings });
                    // return;
                }
            }
            // return new Promise((resolve, reject) => {
            //     api({ url: '/templates/check_template_change/', data: { uid: current_uid, settings: settings }, method: 'POST' })
            //         .then(resp => {
            //             const result = resp.data.changed
            //             console.log("IS CHANGED" + JSON.stringify(resp.data.changed))
            //             localStorage.setItem('template_changed', result === true)
            //             commit("setTemplateChanged", { value: (result === true) });
            //             resolve(resp)
            //         })
            //         .catch(err => {
            //             let msg = err.response.data.detail
            //                 // console.log(JSON.stringify(err.response))
            //             console.log("MYErROR: " + msg)
            //             reject(err)
            //         })
            // })
        },
        setFilterKey({ commit, dispatch }, { key, value }) {
            // console.log(`Updating ${key} = ${value}`);
            commit("setFilterKey", { key, value });
            dispatch("isTemplateChanged");
            commit({
                type: "setCurrentPage",
                page: 1
            });
        },
        deleteFilterKey({ commit, dispatch }, { key_to_delete }) {
            // console.log(`Deleting ${key_to_delete}`);
            commit("deleteFilterKey", { key_to_delete });
            dispatch("isTemplateChanged");
            commit({
                type: "setCurrentPage",
                page: 1
            });
        },
        setMenu({ commit }) {
            commit("setMenu")
        },
        addHighlight({ commit, dispatch }, { type, value }) {
            // console.log(`Updating ${type} = ${value}`);
            commit("addHighlight", { type, value });
            dispatch("isTemplateChanged");
        },
        deleteHighlight({ commit, dispatch }, { type, value }) {
            // console.log(`Deleting ${type} = ${value}`);
            commit("deleteHighlight", { type, value });
            dispatch("isTemplateChanged");
        },
        deleteCol({ commit, dispatch }, { col_to_delete }) {
            commit("deleteCol", { col_to_delete })
            dispatch("isTemplateChanged");
            commit({
                type: "setCurrentPage",
                page: 1
            });
        },
        addCol({ commit, dispatch }, { value }) {
            commit("addCol", { value })
            dispatch("isTemplateChanged");
            commit({
                type: "setCurrentPage",
                page: 1
            });
        },
        setCols({ commit, dispatch }, { value }) {
            commit("setCols", { value })
            dispatch("isTemplateChanged");
            commit({
                type: "setCurrentPage",
                page: 1
            });
        },
        setColors({ commit, dispatch }, { value }) {
            commit("setColors", { value })
            dispatch("isTemplateChanged");
            commit({
                type: "setCurrentPage",
                page: 1
            });
        },
        cleanSettings({ commit }) {
            // console.log("Cleaning settings");
            commit("cleanSettings")
            commit({
                type: "setCurrentPage",
                page: 1
            });
        },
        setCurrentPage({ commit }, { page }) {
            // console.log("In setPage");
            commit("setCurrentPage", { page });
        },
        setTotalGamesCount({ commit }, { count }) {
            commit("setTotalGames", { count });
        },
        setLoading({ commit }, { value }) {
            commit("setLoading", { value });
        },
        setFinishes({ commit }, { value }) {
            commit("setFinishes", { value });
        },
        setHighlightFighters({ commit }, { value }) {
            commit("setHighlightFighters", { value });
        },
        setHighlightTimes({ commit }, { value }) {
            commit("setHighlightTimes", { value });
        },
        setConfirmDialog({ commit }, { value }) {
            commit("setConfirmDialog", { value });
        },
        setExitDialog({ commit }, { value }) {
            commit("setExitDialog", { value });
        },
        setChangeDialog({ commit }, { value }) {
            commit("setChangeDialog", { value });
        },
        setCurrentTemplate({ commit, dispatch }, { value }) {
            commit("setCurrentTemplate", { value });
            dispatch("setTemplateChanged", { value: false });
        },
        setUserTemplates({ commit, dispatch }, { value }) {
            commit("setUserTemplates", { value });
            dispatch("isTemplateChanged");
            // dispatch("setTemplateChanged", { value: false });
        },
        setTemplateUID({ commit, dispatch }, { value }) {
            commit("setTemplateUID", { value });
            dispatch("isTemplateChanged");
        },
        setTemplateChanged({ commit }, { value }) {
            commit("setTemplateChanged", { value });
        },
        setEmail({ commit }, { value }) {
            commit("setEmail", { value });
        },
        setSettings({ commit, dispatch }, { value }) {
            // console.log("SETTING SETTINGS: " + JSON.stringify(value));
            commit("setSettings", { value });
            dispatch("isTemplateChanged");
            // dispatch("setTemplateChanged", { value: false });
        },

        setPageSize({ commit }, { value }) {
            commit("setPageSize", { value })
        }
    }
});